module.exports = global["jQuery"] = require("-!C:\\git\\xfinity-myplan\\Comcast.MyPlan.Web.Ui\\node_modules\\jquery\\dist\\jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
 ** module id = 964
 ** module chunks = 0
 **/